import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentContentData } from 'projects/app-default/src/app/cms/components/components.interface';
export interface IPageComponentCountdownBannerData extends NICmsContentComponent.IData, ICmsComponentContentData {
    limitVisibility?: boolean;
    eligibleGroupsIds?: string;
    image?: string;
    ratio?: string;
    compact?: boolean;
    link?: string;
    title: string;
    titleStyle?: string;
    titleColor?: string;
    subtitle?: string;
    subtitleStyle?: string;
    subtitleColor?: string;
    horizontalAlignment?: string;
    verticalAlignment?: string;
    countdownStyle?: string;
    countdownColor?: string;
    countdownTextColor?: string;
    ctaText?: string;
    ctaStyle?: string;
    endDate?: Date;
    linkAfterCountdown?: string;
    textAfterCountdown?: string;
    textStyleAfterCountdown?: string;
    textColorAfterCountdown?: string;
    subtitleAfterCountdown?: string;
    subtitleStyleAfterCountdown?: string;
    subtitleColorAfterCountdown?: string;
    ctaTextAfterCountdown?: string;
    ctaStyleAfterCountdown?: string;
}
export enum EHorizontalAlignmentVariant {
    left = 'left',
    center = 'center',
    right = 'right'
}
export enum EVerticalAlignmentVariant {
    top = 'top',
    middle = 'middle',
    bottom = 'bottom'
}
